var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#cd0f41;}.b{fill:#cd0f41;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.5 -733.605)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-247.182 293.718)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(256.182 440.387)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M185.926,102.056a1.051,1.051,0,0,0,0-1.485l-6.23-6.23a1.053,1.053,0,0,1,0-1.487h0a1.053,1.053,0,0,1,1.487,0l7.715,7.716a1.048,1.048,0,0,1,0,1.485l-7.715,7.716a1.053,1.053,0,0,1-1.487,0h0a1.053,1.053,0,0,1,0-1.487Z",
    transform: "translate(208.904 853.08) rotate(180)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsq);
export default __webpack_public_path__ + "static/media/isq.d3fc988a18ab1ce0c2c1ee01eaeae1c5.svg";
export { ForwardRef as ReactComponent };